// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1d0TP","title":"Info_title__299wD","links":"Info_links__ucOwO","link":"Info_link__36se3","logo":"Info_logo__2zuXC"};